import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class OrgInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentOrg = this.authService.getCurrentOrganization();
    const authToken = this.authService.getAuthToken();

    // Add org context to headers
    if (currentOrg) {
      request = request.clone({
        setHeaders: {
          'X-Org-Id': currentOrg.OrgId.toString(),
          'X-Unit-Id': currentOrg.OrgUnits[0]?.UnitId.toString() || '',
          'OrgId': currentOrg.OrgId.toString(),
          'UnitId': currentOrg.OrgUnits[0]?.UnitId.toString() || ''
        }
      });
    }

    // Add auth token
    if (authToken && !request.url.includes('/login')) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`
        }
      });
    }

    return next.handle(request);
  }
}
